import CustomScrollbarOptions = MCustomScrollbar.CustomScrollbarOptions;
import {animate, group, state, style, transition, trigger} from "@angular/animations";

export function markFields(form) {
  Object.keys(form.controls).forEach(field => {
    form.get(field).markAsTouched({onlySelf: true});
  });
}
export function generateRandomString(length) {
  let text = "";
  const char_list = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < length; i++) {
    text += char_list.charAt(Math.floor(Math.random() * char_list.length));
  }
  return text;
}
export function downloadDataAsFile(exportData, exportName = 'deliver-sense-export', fileType= 'csv') {
  const dataStr = `${fileType === 'json' ? "data:text/json;charset=utf-8," : "data:text;charset=utf-8,"}` + encodeURIComponent(exportData);
  const downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute("href", dataStr);
  downloadAnchorNode.setAttribute("download", exportName + `${fileType === 'json' ? ".json" : ".csv"}`);
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}

export const scrollbarOptions = <CustomScrollbarOptions>{axis: 'y', theme: 'minimal-dark'};
export const tablescrollbarOptions = <CustomScrollbarOptions>{theme: 'minimal-dark'};
export const thirdPartyReportingModule = 'vlBJZeknUiMFjkSqj6F6';
export const exemptSalesManagementModule = 'WHTZNRSd7qRMiz2nTO84';
export const auditTrailsModule = 'ru8bwRnug0X6Q6bLZwHX';

export function getErrorCodeMessage(code) {
  const errorCodeMap = {};
  return errorCodeMap[code] ? errorCodeMap[code] : 'Unknown error occurred.';
}

export const tableExpandAnimation = [
  trigger('detailExpand', [
    state('collapsed', style({height: '0px', minHeight: '0'})),
    state('expanded', style({height: '*'})),
    transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  ]),
];

export const SlideInOutAnimation = [
  trigger('slideInOut', [
    transition(':enter', [
      style({transform: 'translateX(-100%)'}),
      animate('200ms ease-in', style({transform: 'translateX(0%)'}))
    ]),
    transition(':leave', [
      animate('200ms ease-in', style({transform: 'translateX(200%)'}))
    ])
  ])
];
export const staticImageLocations = {
  amexLogo: 'https://firebasestorage.googleapis.com/v0/b/vexed-creative.appspot.com/o/static%2Famex_logo.png?alt=media&token=68517f1c-174c-40b3-ae36-243433c375f3',
  visaLogo: 'https://firebasestorage.googleapis.com/v0/b/vexed-creative.appspot.com/o/static%2Fvisa.png?alt=media&token=00ee179e-6bb9-4ba2-877e-c198dbb1503a',
  discoverLogo: 'https://firebasestorage.googleapis.com/v0/b/vexed-professional.appspot.com/o/static%2Fdiscover_logo.jpg?alt=media&token=842f9169-8033-4691-a353-c6f5cc2f3206',
  masterCardLogo: 'https://firebasestorage.googleapis.com/v0/b/vexed-creative.appspot.com/o/static%2Fmc_logo.png?alt=media&token=369d153f-cff2-4798-821c-6a706b1f28bc',
  imagePlaceholder: 'https://firebasestorage.googleapis.com/v0/b/vexed-creative.appspot.com/o/static%2Fimage-placeholder.png?alt=media&token=238f185d-cfb9-4f07-8bf3-61b25b9bc007',
  lpSecondImage: 'https://firebasestorage.googleapis.com/v0/b/vexed-creative.appspot.com/o/static%2Flight_and_dark.jpg?alt=media&token=43fe5c25-7f5f-4de7-97a0-4b075395cfc0',
  lpMainImage: 'https://firebasestorage.googleapis.com/v0/b/vexed-creative.appspot.com/o/static%2Fvexli_car_hood.jpg?alt=media&token=0bb73ace-1244-4b4a-b0af-f78efca46f10',
  logoLarge: 'https://firebasestorage.googleapis.com/v0/b/deliver-sense-web-test.appspot.com/o/static%2Flogo-medium.png?alt=media&token=f5d41819-8886-4edc-94dd-79e860d7850d',
  logoLargeWhite: 'https://firebasestorage.googleapis.com/v0/b/deliver-sense-web-test.appspot.com/o/static%2Flogo-medium-white.png?alt=media&token=bce2639c-bfa1-4552-bdb2-9cc2a68a06b4',
  logoXtraLarge: 'https://firebasestorage.googleapis.com/v0/b/deliver-sense-web-test.appspot.com/o/static%2Flogo_large.png?alt=media&token=907ba9cf-4d74-4393-a8c8-defaaf9b95bb',
  logoXtraLargeWhite: 'https://firebasestorage.googleapis.com/v0/b/deliver-sense-web-test.appspot.com/o/static%2Flogo_large_white.png?alt=media&token=e6691f0a-84a4-4ec4-8641-d8c11e7812b8',
  iconOfficial: "https://firebasestorage.googleapis.com/v0/b/deliver-sense-web-test.appspot.com/o/static%2Ficon-512x512.png?alt=media&token=9ba2e21d-f664-4a8e-a6f9-6c07f9075d44",
  offeringPlaceholder: "https://firebasestorage.googleapis.com/v0/b/prodville-test.appspot.com/o/static%2Foffering-placeholder.png?alt=media&token=49ecba43-627e-4ab5-b7e8-d5855ea2c30d",
  videoPlaceholder: 'https://firebasestorage.googleapis.com/v0/b/vexed-creative.appspot.com/o/static%2Fvideo-sample-placeholder.png?alt=media&token=c272b052-1235-4087-945f-b6e9008d3e61',
  cookie: 'https://firebasestorage.googleapis.com/v0/b/vexed-professional-lab.appspot.com/o/static%2Fcookie.png?alt=media&token=a81d25a2-0655-4659-85b8-877669ba7b36'
};

export const placeholderUrl = staticImageLocations.imagePlaceholder;
export const cardImageSources = {
  Visa: staticImageLocations.visaLogo,
  Discover: staticImageLocations.discoverLogo,
  MasterCard: staticImageLocations.masterCardLogo,
  "American Express": staticImageLocations.amexLogo
};
export const bulkLocationUploadTemplate = 'https://firebasestorage.googleapis.com/v0/b/deliver-sense-app-dev.appspot.com/o/data-sheets%2Fdeliver-sense-locations-upload-template.csv?alt=media&token=a33c15bb-149c-471c-8808-2a0b3d4e3ebf';
export const bulkLocation3pdRateTemplate = 'https://firebasestorage.googleapis.com/v0/b/deliver-sense-app-dev.appspot.com/o/data-sheets%2Fdeliver-sense-locations-3pd-rates-template.csv?alt=media&token=f9a68ffc-dd7d-4278-b230-332cba1bfd27';
export const getPlaceholderImage = {url: staticImageLocations.offeringPlaceholder};


export class Tutorial {
  title: string;
  summary: string;
  steps: TutorialStep[];
}

export class TutorialStep {
  title: string;
  targets: string[];
  source: string;
  delay: number;
  scrollTo: string; // id of element to scrollTo;
  startAction: string; // id of element to click;
  endAction: string; // id of element to click on exit;
  arrowText: string;
  mainText: string;
  mainImage: string;
}

/*******************************************************************/
/*******************************************************************/
/*******************************************************************/

/*******************************************************************/
export function dashboardTutorial() {
  const tutorial = new Tutorial();
  const tutorialSteps = [];
  tutorial.title = "Welcome To DeliverSense!";
  tutorial.summary = "Here is an overview of the application. Click 'Start' to begin the application tutorial.";
  tutorial.steps = tutorialSteps;
  // Organization
  const orgNavTutorialStep = new TutorialStep();
  orgNavTutorialStep.title = 'Setup Your Organization and Manage Your Team';
  orgNavTutorialStep.arrowText = 'Expand Links';
  orgNavTutorialStep.source = 'tutorial-sheet';
  orgNavTutorialStep.targets = ['org-nav-link'];
  orgNavTutorialStep.startAction = '#org-nav-link';
  orgNavTutorialStep.endAction = '#org-nav-link';
  orgNavTutorialStep.mainText = 'This link expands to show links to manage your organization: team members, locations, entities, departments, and projects.'
  // Client Selector
  const clientSelectTutorialStep = new TutorialStep();
  clientSelectTutorialStep.title = 'Work In Multiple Company Accounts with One Login!';
  clientSelectTutorialStep.arrowText = 'Select';
  clientSelectTutorialStep.source = 'tutorial-sheet';
  clientSelectTutorialStep.targets = ['header-client-selector'];
  clientSelectTutorialStep.startAction = '#header-client-selector';
  clientSelectTutorialStep.endAction = '#header-client-selector';
  clientSelectTutorialStep.mainText = 'You can toggle between clients that you are working in using the client selector in the top navigation bar; a handy feature for' +
    'consultants who work with multiple DeliverSense customers.';
  // Module Links
  const moduleLinksTutorialStep = new TutorialStep();
  moduleLinksTutorialStep.title = 'Your Company Modules';
  moduleLinksTutorialStep.arrowText = '';
  moduleLinksTutorialStep.source = 'tutorial-sheet';
  moduleLinksTutorialStep.targets = ['exemption-certificate-module-link', 'audit-trails-module-link', 'third-party-report-module-link'];
  moduleLinksTutorialStep.mainText = 'Below the organization links you will find the links to the modules that your company subscribes to.';
// notifications
  const userOptionsTutorialStep = new TutorialStep();
  userOptionsTutorialStep.title = 'Manage Your Global Profile';
  userOptionsTutorialStep.arrowText = '';
  userOptionsTutorialStep.source = 'tutorial-sheet';
  userOptionsTutorialStep.targets = ['header-user-actions-button'];
  userOptionsTutorialStep.mainText = 'Click your username to manage your global profile or logout.';
  // User Info
  const userNotificationTutorialStep = new TutorialStep();
  userNotificationTutorialStep.arrowText = '';
  userNotificationTutorialStep.title = 'Client Specific Notifications';
  userNotificationTutorialStep.source = 'tutorial-sheet';
  userNotificationTutorialStep.targets = ['header-notification-button'];
  userNotificationTutorialStep.startAction = '#header-notification-button';
  userNotificationTutorialStep.endAction = '#header-notification-button';
  userNotificationTutorialStep.mainText = 'See notifications specific to the selected client account. Notifications can include platform notifications, review requests,' +
    'or other module specific notifications.';
  // client branding
  const clientBrandingTutorialStep = new TutorialStep();
  clientBrandingTutorialStep.arrowText = '';
  clientBrandingTutorialStep.title = 'Manage Your Client Account';
  clientBrandingTutorialStep.source = 'tutorial-sheet';
  clientBrandingTutorialStep.targets = ['header-client-brand', 'nav-client-settings'];
  clientBrandingTutorialStep.mainText = "If you have admin access to the currently selected client you can brand the account with your company's logo and edit other client settings.";
  // Add steps
  tutorialSteps.push(orgNavTutorialStep);
  tutorialSteps.push(moduleLinksTutorialStep);
  tutorialSteps.push(clientSelectTutorialStep);
  tutorialSteps.push(userOptionsTutorialStep);
  tutorialSteps.push(userNotificationTutorialStep);
  tutorialSteps.push(clientBrandingTutorialStep);
  return tutorial
}

export function teamMembersTutorial() {
  const tutorial = new Tutorial();
  const tutorialSteps = [];
  tutorial.title = "Team Members";
  tutorial.summary = `Here you will be able to manage client team members. This includes inviting new team members via email, removing team members, and updating access to entities, departments,
   locations, and projects.`;
  tutorial.steps = tutorialSteps;
  return tutorial

}

export function locationsTutorial() {
  const tutorial = new Tutorial();
  const tutorialSteps = [];
  tutorial.title = "Locations";
  tutorial.summary = "This section will allow you to manage the client locations. Client locations include tax and accounting" +
    "profiles that enables module features such as '3PD Reporting' reconciliation automation.";
  tutorial.steps = tutorialSteps;
  return tutorial

}

export function locationTutorial() {
  const tutorial = new Tutorial();
  const tutorialSteps = [];
  tutorial.title = "Location Information and Rate Management";
  tutorial.summary = "This page allows the user to edit basic location information and manage the" +
    "'accounting profile' (i.e. tax rates, fee rates, and delivery partner information specific to the location).";
  tutorial.steps = tutorialSteps;
  return tutorial

}

export function thirdPartyReportsTutorial() {
  const tutorial = new Tutorial();
  const tutorialSteps = [];
  tutorial.title = "3PD Report";
  tutorial.summary = 'The table lists saved client third party delivery reports.' +
    'Click on one of the saved reports to start running a report using the saved parameters.';
  tutorial.steps = tutorialSteps;
  return tutorial

}

export function thirdPartyCreateReportTutorial() {
  const tutorial = new Tutorial();
  const tutorialSteps = [];
  tutorial.title = "Run 3PD Reports";
  tutorial.summary = 'The 3PD report generator pulls data from the selected 3PD partners and the client\'s internal POS or transaction system;' +
    'using a selected date range, to report compares the transactions between the systems and reconciles the information.';
  tutorial.steps = tutorialSteps;
  // parameters
  const selectParametersStep = new TutorialStep();
  selectParametersStep.title = 'Set the Report Parameters';
  selectParametersStep.source = 'tutorial-sheet';
  selectParametersStep.endAction = '#run-third-party-report-button';
  selectParametersStep.targets = ['select-locations', 'select-third-parties', 'select-start-date', 'select-end-date'];
  selectParametersStep.mainText = 'To run a 3PD reconciliation report you must select one or more locations, a 3PD partner, a start and an end date.' +
    "These parameters will be used to pull transaction data from the client's POS system and the selected delivery partners transaction records.";
  tutorialSteps.push(selectParametersStep);
  // reportInfo
  const locationSummaryStep = new TutorialStep();
  locationSummaryStep.title = 'Transaction Reporting';
  locationSummaryStep.source = 'tutorial-sheet';
  locationSummaryStep.delay = 500;
  locationSummaryStep.targets = ['pos-sales', 'third-party-sales', 'pos-tax', 'third-party-tax', 'third-party-effective-tax', 'location-tax'];
  locationSummaryStep.mainText = 'After the transactions have been pulled, a summary row for each location will summarize the ' +
    'sales, tax collection and effective tax rate for each location identifying disparities between the systems.';
  tutorialSteps.push(locationSummaryStep);
  // drilldown reports
  const drillDownStep = new TutorialStep();
  drillDownStep.title = 'Drill Down Reports';
  drillDownStep.source = 'tutorial-sheet';
  drillDownStep.startAction = '#expand-reports';
  drillDownStep.targets = ['match-level'];
  drillDownStep.mainText = 'Expand the row to view the drill down reports generated by the AI reconciliation engine. These reports will match the transactions ' +
    'between the POS and 3PD, automating the process of identifying discrepancies between the systems. This will assist in tax reporting, remittance validation' +
    'and effective management of the 3PD integrations.';
  tutorialSteps.push(drillDownStep);

  return tutorial

}

export function auditTrailsTutorial() {
  const tutorial = new Tutorial();
  const tutorialSteps = [];
  tutorial.title = "Audit Trails";
  tutorial.summary = 'Audit trails enables the team and invited external parties to more efficiently manage the work review process. Using project permission settings, ' +
    'the table on this page lists all the Audit Trail documents and review notes available to you based on your project access.';
  tutorial.steps = tutorialSteps;
  const newAuditTrailStep = new TutorialStep();
  newAuditTrailStep.arrowText = '';
  newAuditTrailStep.title = 'New Audit Trails';
  newAuditTrailStep.source = 'tutorial-sheet';
  newAuditTrailStep.targets = ['upload-audit-trails-button', 'create-new-audit-trails-button'];
  newAuditTrailStep.mainText = "New documents that your team wants to track review comments for can be created manually or by uploading an excel document. Uploaded documents are " +
    "intelligently parsed for tab name to automatically create review sections.";
  tutorialSteps.push(newAuditTrailStep);
  const exisitingAuditTrailSteps = new TutorialStep();
  exisitingAuditTrailSteps.arrowText = '';
  exisitingAuditTrailSteps.title = 'Current Statuses';
  exisitingAuditTrailSteps.source = 'tutorial-sheet';
  exisitingAuditTrailSteps.targets = ['open-comments-cell', 'approved-comments-cell', 'completed-status-cell'];
  exisitingAuditTrailSteps.mainText = "The list of existing Audit Trail documents shows the review status of each document. Open comments are pending or " +
    "have been completed by the assignee. Once the reviewer has approved a comment it will appear in the 'Approved' column. Once all the comments have been approved, " +
    "the status will appear as completed.";
  tutorialSteps.push(exisitingAuditTrailSteps);
  return tutorial
}

export function auditTrailTutorial() {
  const tutorial = new Tutorial();
  const tutorialSteps = [];
  tutorial.title = "Comment Manager";
  tutorial.summary = "Audit Trail's comment manager is where the your team will create, assign, track and resolve work review comments.";
  tutorial.steps = tutorialSteps;
  const pageTabSteps = new TutorialStep();
  pageTabSteps.arrowText = '';
  pageTabSteps.title = 'Review Sections';
  pageTabSteps.source = 'tutorial-sheet';
  pageTabSteps.targets = ['audit-trails-tab'];
  pageTabSteps.mainText = "Sections enable the review to be organized by pages, topics or spreadsheet tabs.";
  tutorialSteps.push(pageTabSteps);
  const addSectionsStep = new TutorialStep();
  addSectionsStep.arrowText = '';
  addSectionsStep.title = 'Adding Sections';
  addSectionsStep.source = 'tutorial-sheet';
  addSectionsStep.targets = ['add-section-button'];
  addSectionsStep.mainText = "If a spreadsheet is uploaded the sections will be created automatically using the tab names. If the review document changes during the course of the review process you can add additional sections to represent the new topic or tab.";
  tutorialSteps.push(addSectionsStep);
  const commentsListStep = new TutorialStep();
  commentsListStep.arrowText = '';
  commentsListStep.title = 'Adding and Managing Comments';
  commentsListStep.source = 'tutorial-sheet';
  commentsListStep.startAction = '.mat-expansion-panel-header';
  commentsListStep.endAction = '.mat-expansion-panel-header';
  commentsListStep.targets = ['add-comment-button', 'comment-text', 'resolution-text', 'assignee-selector', 'status-selector'];
  commentsListStep.mainText = "Within each section, a list of the comments will showcase review notes, the assignee and status. Expand the row to update the comment" +
    "based on your role. An assignee can add a response and change the status to either pending or completed. The creator of the " +
    "comment can update the review notes, change the assignee, and update the status to pending, approved, or cancelled.";
  tutorialSteps.push(commentsListStep);
  return tutorial
}

export function exemptionCertificateTutorial() {
  const tutorial = new Tutorial();
  const tutorialSteps = [];
  tutorial.title = "Exemption Certificate Manager";
  tutorial.summary = "This module enable a client to efficiently manage and document tax exempt sales transactions." +
    "The table automatically populates with tax exempt transactions from the client's POS or internal transaction system.";
  tutorial.steps = tutorialSteps;
  const documentedStatusStep = new TutorialStep();
  documentedStatusStep.arrowText = '';
  documentedStatusStep.title = 'Support Status';
  documentedStatusStep.source = 'tutorial-sheet';
  documentedStatusStep.targets = ['documented-status'];
  documentedStatusStep.mainText = "This icon indicates whether the transaction has attached support validating the tax exemption. A check mark means the transaction is properly documented.";
  const expandDetailsStep = new TutorialStep();
  expandDetailsStep.arrowText = '';
  expandDetailsStep.title = 'Upload Documentation';
  expandDetailsStep.startAction = '#expand-exemption-details';
  expandDetailsStep.source = 'tutorial-sheet';
  expandDetailsStep.targets = ['expand-exemption-details'];
  expandDetailsStep.mainText = "Expand the row to upload exemption support (pdf or image files), download/edit existing documentation, and add notes.";
  const exportCertificatesStep = new TutorialStep();
  exportCertificatesStep.arrowText = '';
  exportCertificatesStep.title = 'Export Documentation';
  exportCertificatesStep.source = 'tutorial-sheet';
  exportCertificatesStep.targets = ['export-tax-exempt-documentation'];
  exportCertificatesStep.mainText = "Click the export button to download exempt sales information and certificates.";
  tutorialSteps.push(documentedStatusStep);
  tutorialSteps.push(expandDetailsStep);
  tutorialSteps.push(exportCertificatesStep);
  return tutorial;
}

export function clientSettingTutorial() {
  const tutorial = new Tutorial();
  const tutorialSteps = [];
  tutorial.title = "Client Settings";
  tutorial.summary = `A client admin will be able to update account information, view the client's enabled modules, and manage payments. `;
  tutorial.steps = tutorialSteps;
  return tutorial

}
